import {
    cardAhri,
    cardAshe,
    cardGaren,
    cardFortune,
    cardAkali,
    cardLux,
    bgGaren,
    bgLux,
    bgFortune,
    bgAshe,
    bgAhri,
    bgAkali,
    bgLargeAshe,
    bgLargeAhri,
    bgLargeFortune,
    bgLargeLux,
    bgLargeGaren,
    bgLargeAkali
} from './images'

export const championsData = [
    {
        img: cardAkali,
        name: 'akali',
        bg: bgAkali,
        nickName: 'THE ROGUE ASSASSIN',
        role: 'ASSASSIN',
        difficulty: 'MODERATE',
        description: `Abandoning the Kinkou Order and her title of the Fist of Shadow, Akali now strikes alone, ready to be the deadly weapon her people need. Though she holds onto all she learned from her master Shen, she has pledged to defend Ionia from its enemies, one kill at a time. Akali may strike in silence, but her message will be heard loud and clear: fear the assassin with no master.`,
        video: 'sQ7ALTSCbdw',
        bgLarge: bgLargeAkali
    },
    {
        img: cardFortune,
        name: 'miss fortune',
        bg: bgFortune,
        nickName: 'THE BOUNTY HUNTER',
        role: 'MARKSMAN',
        difficulty: 'LOW',
        description: 'A Bilgewater captain famed for her looks but feared for her ruthlessness, Sarah Fortune paints a stark figure among the hardened criminals of the port city. As a child, she witnessed the reaver king Gangplank murder her family—an act she brutally avenged years later, blowing up his flagship while he was still aboard. Those who underestimate her will face a beguiling and unpredictable opponent… and, likely, a bullet or two in their guts.',
        video: 'TN-EdiIg4G4',
        bgLarge: bgLargeFortune
    },
    {
        img: cardAshe,
        name: 'ashe',
        bg: bgAshe,
        nickName: 'THE FROST ARCHER',
        role: 'MARKSMAN',
        difficulty: 'MODERATE',
        description: `Iceborn warmother of the Avarosan tribe, Ashe commands the most populous horde in the north. Stoic, intelligent, and idealistic, yet uncomfortable with her role as leader, she taps into the ancestral magics of her lineage to wield a bow of True Ice. With her people's belief that she is the mythological hero Avarosa reincarnated, Ashe hopes to unify the Freljord once more by retaking their ancient, tribal lands.`,
        video: 'mSbMQ5xDnEg',
        bgLarge: bgLargeAshe
    },
    {
        img: cardGaren,
        name: 'garen',
        bg: bgGaren,
        nickName: 'THE MIGHT OF DEMACIA',
        role: 'FIGHTER',
        difficulty: 'MODERATE',
        description: `A proud and noble warrior, Garen fights as one of the Dauntless Vanguard. He is popular among his fellows, and respected well enough by his enemies—not least as a scion of the prestigious Crownguard family, entrusted with defending Demacia and its ideals. Clad in magic-resistant armor and bearing a mighty broadsword, Garen stands ready to confront mages and sorcerers on the field of battle, in a veritable whirlwind of righteous steel.`,
        video: 'Q7oyW6LjxrA',
        bgLarge: bgLargeGaren
    },
    {
        img: cardAhri,
        name: 'ahri',
        bg: bgAhri,
        nickName: 'THE NINE-TAILED FOX',
        role: 'MAGE',
        difficulty: 'MODERATE',
        description: 'Innately connected to the latent power of Runeterra, Ahri is a vastaya who can reshape magic into orbs of raw energy. She revels in toying with her prey by manipulating their emotions before devouring their life essence. Despite her predatory nature, Ahri retains a sense of empathy as she receives flashes of memory from each soul she consumes.',
        video: '0z7kfuJwGvs',
        bgLarge: bgLargeAhri
    },
    {
        img: cardLux,
        name: 'Lux',
        bg: bgLux,
        nickName: 'THE LADY OF LUMINOSITY',
        role: 'MAGE',
        difficulty: 'MODERATE',
        description: `Luxanna Crownguard hails from Demacia, an insular realm where magical abilities are viewed with fear and suspicion. Able to bend light to her will, she grew up dreading discovery and exile, and was forced to keep her power secret, in order to preserve her family's noble status. Nonetheless, Lux's optimism and resilience have led her to embrace her unique talents, and she now covertly wields them in service of her homeland.`,
        video: 'khEBkz6A0oQ',
        bgLarge: bgLargeLux
    },
]